<template>
  <div id="app">
    <Header v-if="header === true"></Header>
    <div class="app" v-cloak>
      <!--      <transition :name="transitionName">-->
      <keep-alive :include="include" :max="10">
        <router-view class="router" ref="router"></router-view>
      </keep-alive>
      <!--      </transition>-->
    </div>
    <Footer v-if="footer === true" :beian="beian"></Footer>
    <Home v-if="home === true"></Home>
    <div class="rotating-box">
      <div class="rotating-div"></div>
    </div>
    <Login v-if="auth && !isLogin"></Login>
    <!-- <ScreenSaver v-if="isLogin"></ScreenSaver> -->
    <Welcome :visible="showWelcome" @hide="hideWelcome"></Welcome>
  </div>
</template>
<script>
function isKeepAlive($route) {
  return $route.meta.keepAlive === undefined || $route.meta.keepAlive;
}
// import ScreenSaver from '@components/ScreenSaver.vue';
import Header from "@components/Header";
import Footer from "@components/Footer";
import Login from "@components/Login";
import Home from "@components/Home";
import Welcome from "@views/Welcome";
import { mapGetters } from "vuex";
import { isWeixin } from "@utils/index";

export default {
  data() {
    return {
      transitionName: "fold-right",
      include: isKeepAlive(this.$route) ? [this.$route.name] : [],
      history: [],
      beian:'',
    };
  },
  provide() {
    return {
      app: this
    };
  },
  computed: mapGetters(["footer", "home", "isLogin", "header", 'auth', 'showWelcome']),
  components: {
    Footer,
    Header,
    Home,
    Login,
    Welcome,
    // ScreenSaver
  },
  watch: {
    $route(to, from) {
      const lastPath = this.history[this.history.length - 1] || {},
        { isReplace, isBack } = this.$router;

      if (lastPath.path === to.path) {
        this.transitionName = "fold-right";
        this.history.pop();
      } else {
        this.transitionName = "fold-left";
        if (!isReplace) this.history.push({ path: from.path, name: from.name });
      }

      if (isKeepAlive(to) && to.name !== "Login") {
        !this.include.includes(to.name) && this.include.push(to.name);
      }

      if (isKeepAlive(from) && isBack) {
        var index = this.include.indexOf(from.name);
        index !== -1 && this.include.splice(index, 1);
      }

      this.$router.isBack = false;
      this.$router.isReplace = false;

      console.log(this.transitionName, "change");
    }
  },
  mounted: function() {
    this.setOpenShare();
  },
  methods: {
    setOpenShare: function() {
    },
    hideWelcome() {
      this.$store.commit('HIDE_WELCOME');
    }
  }
};
</script>
<style lang="scss">
[v-cloak] {
  display: none !important;
}

.router {
  width: 100%;
}

.fold-left-enter-active {
  animation-name: fold-left-in;
  animation-duration: 0.5s;
}

.fold-left-leave-active {
  animation-name: fold-left-out;
  animation-duration: 0.5s;
}

@keyframes fold-left-in {
  0% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-left-out {
  0% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}

.fold-right-enter-active {
  animation-name: fold-right-in;
  animation-duration: 0.5s;
}

.fold-right-leave-active {
  animation-name: fold-right-out;
  animation-duration: 0.5s;
}

@keyframes fold-right-in {
  0% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes fold-right-out {
  0% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  10% {
    width: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
  100% {
    width: 100%;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
#app {
  background-image: url("assets/images/app_bg.png");
  background-size:cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background-color: #10569e;
}
.app {
  height: 100%;
  position: relative;
  z-index: 3;

  .router {
    z-index: 2;
  }
}
.rotating-box {
  width: 1680px; /* 设置宽度 */
  height: 100vh;
  position: absolute; /* 设置绝对定位 */
  left: 50%;
  transform: translateX(-50%);
  overflow: hidden;
  z-index: 1;
  top: 0;
}
.rotating-div {
    width: 1680px; /* 设置宽度 */
    height: 1680px; /* 设置高度 */
    background-image: url("assets/images/app_bg_i.png");
    background-size: 100%;
    position: absolute; /* 设置绝对定位 */
    top: 57%;
    left: 50%;
    transform: translate(-50%, -50%); /* 使 div 的中心点与父容器的中心点对齐 */
    animation: rotate360 3s linear infinite; /* 应用动画 */
		z-index: 1;
    overflow: hidden;
}
@keyframes rotate360 {
  from {
    transform: translate(-50%, -50%) rotate(0deg);
  }
  to {
    transform: translate(-50%, -50%) rotate(360deg);
  }
}

</style>
